import React, {useEffect, useState} from "react";
import {Form, Select, Button, AutoComplete} from "antd";
import { getPurchasesAsSelect } from "../../services/servicePurchase";
import { warehouseIncomingMulti } from "../../services/serviceWarehouseIncoming";
import { enterLoadingState, exitLoadingState } from "../../utils/helpers/commonFunctions";

const {Option} = AutoComplete

const formLayout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16}
}

const WarehouseMultiCreate = ({modalCloseSignal, warehouses, loadSignal}) => {
    const [form] = Form.useForm();
    const [purchases, setPurchases] = useState();
    const [loadings, setLoadings] = useState([]);

    useEffect(() => {
        getPurchasesAsSelect()
          .then(({data}) => {
            if(data.length) {
              const structuredData = data.map((item) => {
                return {value: item.key, label: item.label}
              })
              setPurchases(structuredData);
            }
          })
    }, []);

    const handleSubmit = ({purchaseNo, warehouse}) => {
      enterLoadingState(setLoadings);
      loadSignal(true);
      warehouseIncomingMulti(purchaseNo, warehouse)
        .then(() => {
          exitLoadingState(setLoadings);
          loadSignal(false);
          modalCloseSignal();
        })
        .catch(() => {
          exitLoadingState(setLoadings)
          loadSignal(false);
        })
    };

    return(
        <React.Fragment>
            <Form
              {...formLayout}
              form={form}
              labelAlign={"left"}
              onFinish={() => handleSubmit(form.getFieldsValue())}
            >
              <Form.Item
                label={'Satın Alma No:'}
                name={'purchaseNo'}
                rules={[
                  {required:true, message: 'Lütfen Satın Alma No Seçiniz'}
                ]}
              >
                <Select
                  showSearch
                  filterOption={(input, option) => 
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                  }
                  options={purchases}
                />
              </Form.Item>
              <Form.Item
                label={'Depo'}
                name={'warehouse'}
                rules={[
                  {required: true, message: 'Lütfen Depo Seçiniz'}
                ]}
              >
                  <Select
                    options={warehouses.map((item) => ({value: item.value, label:item.text}))}
                  />
              </Form.Item>
              <Form.Item>
                <Button type="primary" htmlType="submit" loading={loadings[0]}>Kaydet</Button>
              </Form.Item>
            </Form>
        </React.Fragment>
    )
}

export default WarehouseMultiCreate



